/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
// import { AuthPage } from "../Pages/Auth/AuthPage";
import { RouterProvider } from "react-router-dom";
import { auth } from "../hooks/useAuth";
import { onAuthStateChanged } from "firebase/auth";
import { useAppDispatch, useAppSelector } from "../store";
import { login, refreshToken, selectAuthState } from "../store/Auth/authStore";
import { userLogOut } from "../store/Auth/thunks";
import { router, unauthorizedRouter } from "./router";
import { Notification } from "../Components/Notification/Notification";
import { NewVersionWatcher } from "../Components/NewVersionWatcher";
import { AppErrorBoundary } from "../Components/AppErrorBoundary";
import { Unauthorized } from "./Unauthorized";

const AdminRouter = () => {
  return <RouterProvider router={router} />;
};

const UnauthorizedRouter = () => <RouterProvider router={unauthorizedRouter} />;

export const RouteOnAuth = () => {
  const { profile, unauthorized, errorMessage, statusCode, token } =
    useAppSelector(selectAuthState);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    const listen = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const accessToken = await user.getIdToken();
        dispatch(refreshToken(accessToken));
        dispatch(
          login({
            email: user.email ? user.email : "exempel@gmail.com",
            uid: user.uid,
          })
        );
      } else if (!token && !profile && window.location.pathname !== "/auth")
        dispatch(userLogOut());
      setLoading(false);
    });

    return () => {
      listen();
    };
  }, []);

  if (loading) return <div />;

  return (
    <>
      {!!profile && (
        <React.Suspense fallback={<div />}>
          {/* Router routes carry their own error element; this catches what happens outside a
              route render, so a crash is never a blank page. */}
          <AppErrorBoundary>
            <AdminRouter />
          </AppErrorBoundary>
          <Notification />
          <NewVersionWatcher />
        </React.Suspense>
      )}
      {!profile && (
        <React.Suspense fallback={<div />}>
          {/* <AuthPage /> */}
          <UnauthorizedRouter />
        </React.Suspense>
      )}
      {unauthorized && statusCode === 401 && errorMessage && (
        <Unauthorized message={errorMessage} />
      )}
    </>
  );
};
